import React, { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream-100 px-5 py-16 md:py-24" data-id="element-124" data-mp="x53ex5bncddd">
      <div className="mx-auto max-w-3xl" data-id="element-125" data-mp="121tqbfciaksg">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-126" data-mp="122vd2h2vwvq0">Frequently asked questions</h2>

        <ul className="mt-10 space-y-3" data-id="element-127" data-mp="1ur11bdt5d2ul">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-cream-200" data-id="element-128" data-mp="1g1motwu9y5az" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold-500" data-id="element-129" data-mp="1l06bjzgozl4e">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-700 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-130" data-mp="2ygk0un4xtaox" />
                </button>
                <div id={`faq-${i}`} className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`} data-id="element-131" data-mp="37evqomxzc4gb">
                  <div className="overflow-hidden" data-id="element-132" data-mp="3hcju019nika3">
                    <p className="px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-133" data-mp="3cgupdjiryd6x">{f.a}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>

        <CtaButton className="mt-12" label="I'm ready — get my MasterMap" data-id="element-134" data-mp="1i2tvld230gdp" />
      </div>
    </section>;
}